import { render, staticRenderFns } from "./ServiceAllowedDays.vue?vue&type=template&id=ba044a78"
import script from "./ServiceAllowedDays.vue?vue&type=script&lang=js"
export * from "./ServiceAllowedDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports